import React, { Component } from "react";
import firebase from "../../firebase";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

export default class Banner extends Component {
  state = {
    title: sessionStorage.bannerAdminTitle
      ? sessionStorage.bannerAdminTitle
      : "",
    content: sessionStorage.bannerAdminContent
      ? sessionStorage.bannerAdminContent
      : "",
    warning: false,
    success: false,
    failure: false
  };

  componentDidMount() {
    let content = firebase.database().ref("bannerContent");
    let title = firebase.database().ref("bannerTitle");
    title.on("value", snap => {
      this.setState({ title: snap.val() }, () => {
        sessionStorage.bannerAdminTitle = this.state.title;
      });
    });
    content.on("value", snap => {
      this.setState({ content: snap.val() }, () => {
        sessionStorage.bannerAdminContent = this.state.content;
      });
    });
  }

  handleInput = e => {
    let { value } = e.target;
    this.setState({
      [e.target.name]: value,
      warning: false,
      success: false,
      failure: false
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    let { title, content } = this.state;
    if (!title || !content) return this.setState({ warning: true });
    firebase
      .database()
      .ref()
      .update({ bannerTitle: title, bannerContent: content })
      .then(() => {
        this.setState({ success: true });
      })
      .catch(err => {
        this.setState({ failure: true });
        console.error(`Operation failure: ${err}`);
      });
  };

  render() {
    let { title, content } = this.state;
    let bannerTitle = (
      <div className="banner-title-editor">
        <h2>Banner Title</h2>
        <TextField
          id="bannerTitle"
          label="Banner Title"
          name="title"
          placeholder="Title for the banner on the home page"
          className="banner-fields"
          value={title}
          onChange={this.handleInput}
          margin="normal"
          fullWidth
        />
      </div>
    );
    let bannerContent = (
      <div className="banner-content-editor">
        <h2>Banner Content</h2>
        <TextField
          id="bannerTitle"
          label="Banner Content"
          placeholder="Content for the banner on the home page"
          className="banner-fields"
          value={content}
          onChange={this.handleInput}
          margin="normal"
          name="content"
          multiline
          fullWidth
        />
      </div>
    );

    let sidebar = (
      <div className="sidebar-content">
        <h2>Publish</h2>
        <Divider />
        <Button variant="contained" color="primary" onClick={this.handleSubmit}>
          Submit
        </Button>
      </div>
    );

    return (
      <section className="banner-admin-section">
        <AppBar
          position="static"
          color="default"
          className="banner-admin-title"
        >
          <Toolbar>
            <Typography variant="title" color="inherit">
              Banner Content
            </Typography>
          </Toolbar>
        </AppBar>

        {this.state.warning ? (
          <p className="alert alert-warning">
            The title and content must contain text.
          </p>
        ) : null}
        {this.state.success ? (
          <p className="alert alert-success">Successfully published content!</p>
        ) : null}
        {this.state.failure ? (
          <p className="alert alert-danger">
            Unable to save content. Please try again.
          </p>
        ) : null}

        <article className="banner-admin-display col-xs-12 col-sm-6 col-lg-8">
          {bannerTitle}
          {bannerContent}
        </article>

        <aside className="banner-admin-publish col-xs-12 col-sm-6 col-lg-4">
          {sidebar}
        </aside>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/Banner.js